import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useCookie } from "../../../../hooks/useCookie";
import { useToast } from "../../../../hooks/useToast";
import { general } from "../../../../locales/general";
import { taxiCouponSchema } from "../../../../rules/coupon-validation";
import apiService from "../../../../service/apiService";
import CreateDiscountForm from "../form/CreateDiscountForm";

type FormSchemaType = Yup.InferType<typeof taxiCouponSchema>;

export default function CreateTaxiDiscount() {
  const [isAdvanced, setIsAdvanced] = useState(false);

  const form = useForm<FormSchemaType>({
    resolver: yupResolver(taxiCouponSchema),
    defaultValues: {
      isActive: true,
      isPublic: true,
    },
  });

  const { token } = useCookie("vToken");

  const createDiscountMutation = useMutation({
    mutationFn: (data: FormSchemaType) =>
      apiService.MakePostRequest("taxi-coupons", data, token),
    mutationKey: ["taxi-coupons"],
  });

  const { toastError, toastSuccess } = useToast();
  const navigate = useNavigate();

  const changeRemisMode = (isAdvanced: boolean) => {
    // isAdvanced: true -> switch to advanced mode
    // isAdvanced: false -> switch to simple mode
    if (isAdvanced) {
      // We can always switch to advanced mode (will cause no issues)
      setIsAdvanced(true);
      return;
    }
    // else: we want to switch to simple mode
    // only allowed if we have only one registration and one usage
    const discountFormData = form.getValues("discount");
    const isSimple =
      (discountFormData?.length ?? 0) <= 1 &&
      (discountFormData?.[0].value?.length ?? 0) <= 1
        ? true
        : false;
    if (isSimple) {
      setIsAdvanced(false);
      return;
    }
    // cannot go back to simple mode
    toastError("Impossible de passer du mode simple à mode avancé");
  };

  const onSubmit = (data: FormSchemaType) => {
    createDiscountMutation.mutate(data, {
      onSuccess: () => {
        toastSuccess("Coupon créé avec succès");
        navigate("/taxi/discounts");
        form.reset();
      },
      onError: (error) => {
        toastError(general.fr.message.operationFailed);
      },
    });
  };

  return (
    <div className="bg-white p-3 rounded-md">
      <h1 className="text-lg fw-bold mb-4">Créer un Coupon</h1>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <CreateDiscountForm
          control={form.control}
          isAdvanced={isAdvanced}
          setIsAdvanced={changeRemisMode}
        />
        <button
          className="btn btn-danger text-white my-3 me-2"
          type="button"
          onClick={() => navigate("/taxi/discounts")}
          disabled={createDiscountMutation.isLoading}
        >
          Annuler
        </button>
        <button
          className="btn btn-primary my-3 text-white"
          type="submit"
          disabled={createDiscountMutation.isLoading}
        >
          {createDiscountMutation.isLoading
            ? "Création en cours..."
            : "Créer un Coupon"}
        </button>
      </form>
    </div>
  );
}
